var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9904 16.3655C22.0058 15.1974 22.3236 14.0521 22.9143 13.0361C23.5049 12.0201 24.3492 11.1664 25.3685 10.5546C24.721 9.65168 23.8667 8.90861 22.8735 8.38442C21.8803 7.86022 20.7756 7.56934 19.6472 7.53487C17.24 7.28817 14.9063 8.94116 13.6796 8.94116C12.4292 8.94116 10.5406 7.55936 8.50678 7.60021C7.19128 7.6417 5.90923 8.01517 4.78554 8.68423C3.66184 9.35329 2.73482 10.2951 2.09481 11.4179C-0.677529 16.1042 1.39039 22.9913 4.04611 26.7793C5.37483 28.6342 6.92771 30.7061 8.95965 30.6327C10.948 30.5522 11.6906 29.3948 14.0907 29.3948C16.4686 29.3948 17.1653 30.6327 19.2385 30.586C21.3721 30.5522 22.7164 28.7228 23.9985 26.8504C24.9532 25.5287 25.6878 24.068 26.1751 22.5223C24.9356 22.0105 23.8778 21.1537 23.1336 20.0589C22.3894 18.964 21.9918 17.6795 21.9904 16.3655Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0748 5.04345C19.2382 3.68001 19.8113 1.92754 19.6725 0.158203C17.8952 0.34045 16.2535 1.16975 15.0744 2.48088C14.498 3.12139 14.0565 3.86656 13.7751 4.67377C13.4938 5.48097 13.3782 6.3344 13.4349 7.18525C14.3239 7.19419 15.2034 7.00607 16.0071 6.63508C16.8108 6.26408 17.5178 5.71987 18.0748 5.04345Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.062da64293dbf68c5e04d21338d50641.svg";
export { ForwardRef as ReactComponent };